import React, { useRef, useState } from 'react'
import { GridColumnHeaderParams } from '@mui/x-data-grid-pro'
import InfoTooltip from 'components/InfoTooltip'
import _ from 'lodash'
import Text, { TextColor } from 'particles/Text'
import styled from 'particles/themes/styled'
import { IconColor } from 'particles/Icon'
import Tooltip from 'particles/Tooltip'
import { isOverflown } from 'particles/utils'

type InfoTooltipHeaderCellOptions = {
    mr: string | number
    truncateText?: boolean
}
const defaultOptions: InfoTooltipHeaderCellOptions = {
    mr: 24,
}
interface ContainerProp {
    width: string | number
    textAlign: TextAlign
}
type TextAlign = 'left' | 'center' | 'right'
const Container = styled.div<ContainerProp>`
    display: flex;
    width: ${({ width }) => (width ? width : 'fit-content')};
    min-width: ${({ width }) => (width ? width : 'fit-content')};
    align-items: center;
    justify-content: ${({ textAlign }) => textAlign};
    overflow: hidden;

    .truncate-text {
        text-overflow: ellipsis;
        white-space: nowrap;
        word-wrap: break-word;
        overflow: hidden;
    }
`

interface GetInfoTooltipHeaderParams {
    width: string | number
    title?: string
    description: string
    options?: Partial<InfoTooltipHeaderCellOptions>
    textColor?: TextColor
    iconColor?: IconColor
    textAlign?: TextAlign
}

export const getInfoTooltipHeaderCell = ({
    width,
    title,
    description,
    options = {},
    textColor,
    iconColor,
    textAlign = 'left',
}: GetInfoTooltipHeaderParams) => {
    const { mr, truncateText } = _.merge({}, defaultOptions, options)

    return function InfoTooltipHeaderCell(params: GridColumnHeaderParams): JSX.Element {
        const { headerName } = params.colDef
        const displayWidth = typeof width === 'string' ? width : `${width}px`
        const headerRef = useRef<HTMLDivElement>(null)
        const [showTooltip, setShowTooltip] = useState(false)
        return (
            <Container width={displayWidth} textAlign={textAlign}>
                <Tooltip title={headerName} open={showTooltip}>
                    <Text
                        ref={headerRef}
                        style={{ marginRight: String(mr) }}
                        scale="bodyS500"
                        color={textColor || 'primaryInverse'}
                        textDisplay="inline"
                        className={truncateText ? 'truncate-text' : ''}
                        onMouseEnter={() => {
                            const isNameOverflown = isOverflown(headerRef.current!)
                            setShowTooltip(isNameOverflown)
                        }}
                        onMouseLeave={() => setShowTooltip(false)}
                    >
                        {headerName}
                    </Text>
                </Tooltip>
                <InfoTooltip
                    size="16px"
                    marginLeft="8px"
                    title={title}
                    label={description}
                    iconColor={iconColor || 'actionInverse'}
                />
            </Container>
        )
    }
}
